import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/pub/no-content.png'


const _withScopeId = n => (_pushScopeId("data-v-03b936ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-content-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-content-text" }, "加载失败了，点击屏幕重试", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadWrong',
  emits: ['reloadPage'],
  setup(__props, { emit: emits }) {

    
    const reloadPage = () => {
        emits('reloadPage')
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "no-content",
      onClick: reloadPage
    }, _hoisted_4)
  ]))
}
}

})